"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumFiocInterstitialData = void 0;
const actions_constants_1 = require("./actions.constants");
const PAGE_NAME = 'updateKycModal';
exports.TealiumFiocInterstitialData = {
    [actions_constants_1.FIOC_INTERSTITIAL_OPEN_MODAL]: {
        action: actions_constants_1.TealiumAction.OPEN,
        format: actions_constants_1.TealiumFormat.MODAL,
        component: actions_constants_1.TealiumComponent.FIOC_MODAL,
        element: actions_constants_1.TealiumElement.FULL,
        eventCategory: PAGE_NAME,
        eventAction: actions_constants_1.TealiumEventAction.UPDATE_KYC_MODAL,
        eventLabel: 'open',
    },
    [actions_constants_1.FIOC_INTERSTITIAL_CROSS_ICON]: {
        action: actions_constants_1.TealiumAction.CLOSE,
        format: actions_constants_1.TealiumFormat.ICON,
        component: actions_constants_1.TealiumComponent.FIOC_MODAL,
        element: actions_constants_1.TealiumElement.CROSS,
        eventCategory: PAGE_NAME,
        eventAction: actions_constants_1.TealiumEventAction.UPDATE_KYC_MODAL,
        eventLabel: 'close',
    },
    [actions_constants_1.FIOC_INTERSTITIAL_CANCEL_LINK]: {
        action: actions_constants_1.TealiumAction.CLICK,
        format: actions_constants_1.TealiumFormat.LINK,
        component: actions_constants_1.TealiumComponent.FIOC_MODAL,
        element: 'updateItLater',
        eventCategory: PAGE_NAME,
        eventAction: actions_constants_1.TealiumEventAction.CLICK_LINK,
        eventLabel: 'lowerNavigationModalUpdateItLaterLink',
    },
    [actions_constants_1.FIOC_INTERSTITIAL_GO_TO_PROFILE_BUTTON]: {
        action: actions_constants_1.TealiumAction.CLICK,
        format: actions_constants_1.TealiumFormat.BUTTON,
        component: actions_constants_1.TealiumComponent.FIOC_MODAL,
        element: 'goToPersonalInformation',
        pathName: '/profile',
        eventCategory: PAGE_NAME,
        eventAction: actions_constants_1.TealiumEventAction.CLICK_BUTTON,
        eventLabel: 'lowerNavigationModalGoToPersonalInformationButton',
    },
};
//# sourceMappingURL=tealium.js.map